export class IdiomaCalendario {
	firstDayOfWeek: number;
	dayNames: string[];
	dayNamesShort: string[];
	dayNamesMin: string[];
	monthNames: string[];
	monthNamesShort: string[];
	today: string;
	clear: string;

	constructor() {
	  this.firstDayOfWeek = 1;
	  this.dayNames = [];
	  this.dayNamesShort = [];
	  this.dayNamesMin = [];
	  this.monthNames = [];
	  this.monthNamesShort = [];
	  this.today = '';
	  this.clear = '';
	}
  }



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/IdiomaCalendatio.ts